import React from 'react';
import { Switch, Route, Link as RouterLink } from 'react-router-dom';

import Reports from './routes/Reports';
import ReportDetail from './routes/ReportDetail';
import Katastrophen from './routes/Katastrophen';
import Orte from './routes/Orte';
import EditOrt from './routes/Orte/EditOrt';
import AddOrt from './routes/Orte/AddOrt';
import Notruf from './routes/Notruf';
import Information from './routes/Information';
import Imprint from './routes/Information/Imprint';
import About from './routes/Information/About';
import Privacy from './routes/Information/Privacy';
import TermsOfUse from './routes/Information/TermsOfUse';
import Recommend from './routes/Information/Recommend';

import Updater from './components/Updater';
import RefreshButton from './components/RefreshButton';
import BackButton from './components/BackButton';
import Header from './components/Header';
import NavigationBar from './components/NavigationBar';

const App = () => (
  <div className="AppContainer">
    <Switch>
      <Route
        exact
        path="/"
        render={() => (
          <Header title="Meldungen">
            <RefreshButton />
          </Header>
        )}
      />
      <Route
        exact
        path="/reports"
        render={() => (
          <Header title="Meldungen">
            <RefreshButton />
          </Header>
        )}
      />
      <Route
        exact
        path="/katastrophen"
        render={() => (
          <Header title="Katastrophen">
            <RefreshButton />
          </Header>
        )}
      />
      <Route
        path="/reports/:reportID"
        render={() => (
          <Header title="Meldung">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/reports"
        render={() => (
          <Header title="Meldung">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/katastrophen/:reportID"
        render={() => (
          <Header title="Katastrophe">
            <BackButton />
          </Header>
        )}
      />
      <Route path="/katastrophen" render={() => <Header title="Katastrophe" />} />
      <Route
        path="/orte/addOrt"
        render={() => (
          <Header title="Ort hinzufügen">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/orte/:ort"
        render={() => (
          <Header title="Ort bearbeiten">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/orte"
        render={() => (
          <Header title="Orte">
            <RouterLink to="/orte/addOrt" className="AddOrtButton">
              <i className="fa fa-plus" aria-hidden="true" />
            </RouterLink>
          </Header>
        )}
      />
      <Route path="/notruf" render={() => <Header title="Notruf" />} />
      <Route
        path="/informationen/imprint"
        render={() => (
          <Header title="Impressum">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/informationen/about"
        render={() => (
          <Header title="Über Biwapp">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/informationen/privacy"
        render={() => (
          <Header title="Datenschutzerklärung">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/informationen/termsOfUse"
        render={() => (
          <Header title="Nutzungsbedingungen">
            <BackButton />
          </Header>
        )}
      />
      <Route
        path="/informationen/recommend"
        render={() => (
          <Header title="Weiterempfehlen">
            <BackButton />
          </Header>
        )}
      />
      <Route path="/informationen" render={() => <Header title="Informationen" />} />
    </Switch>
    <Switch>
      <Route exact path="/" component={Reports} />
      <Route exact path="/reports" component={Reports} />
      <Route exact path="/reports/:reportID" component={ReportDetail} />
      <Route exact path="/katastrophen" component={Katastrophen} />
      <Route exact path="/katastrophen/:reportID" component={ReportDetail} />
      <Route exact path="/orte/addOrt" component={AddOrt} />
      <Route exact path="/orte" component={Orte} />
      <Route exact path="/orte/:ort" component={EditOrt} />
      <Route exact path="/notruf" component={Notruf} />
      <Route exact path="/informationen" component={Information} />
      <Route exact path="/informationen/imprint" component={Imprint} />
      <Route exact path="/informationen/about" component={About} />
      <Route exact path="/informationen/privacy" component={Privacy} />
      <Route exact path="/informationen/termsOfUse" component={TermsOfUse} />
      <Route exact path="/informationen/recommend" component={Recommend} />
    </Switch>
    <NavigationBar />
    <Updater />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js